const getDiscountConfig = (productData, isSubscribe) => {
  if (isSubscribe) {
    return {
      enabled: !!productData?.subscription?.subscription_discount_enable,
      settings: productData?.subscription?.subscription_discount_codes,
    };
  }

  return {
    enabled: !!productData?.enable_discount_codes,
    settings: productData?.discount_codes,
  };
};

const getDiscountSettings = (productData, isSubscribe) => getDiscountConfig(productData, isSubscribe).settings;

const isDiscountEnabledForSelection = (productData, isSubscribe) => {
  const config = getDiscountConfig(productData, isSubscribe);
  return !!(config.enabled && config.settings);
};

const isDiscountCodeMatch = (settings, discountCode) => {
  if (!settings || discountCode === undefined || discountCode === null) return false;

  const expected = String(settings.discount_code || "")
    .trim()
    .toUpperCase();
  const actual = String(discountCode).trim().toUpperCase();

  return expected.length > 0 && actual === expected;
};

const isDiscountActive = (productData, isSubscribe, discountCode, isDiscountApplied = true) => {
  const { enabled, settings } = getDiscountConfig(productData, isSubscribe);

  if (!enabled) return false;
  if (!isDiscountCodeMatch(settings, discountCode)) return false;

  return isDiscountApplied !== false;
};

export { getDiscountConfig, getDiscountSettings, isDiscountEnabledForSelection, isDiscountCodeMatch, isDiscountActive };
